"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Detail_1 = require("../Detail");
const hooks_1 = require("../hooks");
exports.MappingCanvasReadyView = () => {
    const { data: { contentMappingId, cmsId }, } = hooks_1.useMappingCanvas('pathParams');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Detail_1.ContentMappingDetail, { contentMappingId: contentMappingId, cmsId: cmsId })));
};
//# sourceMappingURL=index.js.map